import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "ofc_cookie_consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const t = setTimeout(() => setVisible(true), 300);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[90] border-t border-ofc-gold/25 bg-ofc-black/95 backdrop-blur-xl"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
        <p className="text-sm text-white/60 font-light leading-relaxed flex-1">
          Aquest lloc web utilitza únicament cookies tècniques necessàries per al seu funcionament.
          Podeu consultar més informació a la nostra{" "}
          <Link to="/politica-cookies" className="text-ofc-gold hover:text-ofc-goldhover underline underline-offset-4">
            política de cookies
          </Link>
          .
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button
            data-testid="cookie-reject"
            onClick={() => decide("essential")}
            className="px-6 py-3 text-xs uppercase tracking-[0.2em] text-white/70 border border-white/20 hover:border-white/40 hover:text-white transition-colors duration-300"
          >
            Només essencials
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => decide("accepted")}
            className="px-6 py-3 text-xs uppercase tracking-[0.2em] bg-ofc-gold text-ofc-black hover:bg-ofc-goldhover transition-colors duration-300"
          >
            Acceptar
          </button>
        </div>
      </div>
    </div>
  );
};
